import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { Cause } from 'src/app/shared/interfaces/step-data';
import { RequestInformationComponent } from 'src/app/shared/request-information/request-information.component';
import { GetDataService } from 'src/app/shared/services/get-data.service';
import { PutDataService } from 'src/app/shared/services/put-data.service';
import { RequestFormService } from 'src/app/shared/services/request-form.service';
import { AutoUnsubscribeComponent } from 'src/app/shared/utils/auto-unsubscribe.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-step-datos-uber-lto',
  templateUrl: './step-datos-uber-lto.component.html',
  styleUrls: ['./step-datos-uber-lto.component.scss'],
})
export class StepDatosUberLtoComponent
  extends AutoUnsubscribeComponent
  implements OnInit {
  @Input() saveRequest!: Observable<boolean>;
  @Output() formValidEvent = new EventEmitter<boolean>();
  @Output() stepDataUberLtoSavedEvent = new EventEmitter<boolean>();
  public formStepDataUberLto!: FormGroup;
  protected _onDestroy = new Subject<void>();
  public dataUber!: boolean;
  public creditTypeUpdate!: string;
  public enableButtonApproved = false;
  public clicked = false;

  constructor(
    private frmBuilder: FormBuilder,
    private dialog: MatDialog,
    private putDataService: PutDataService,
    private requestFormService: RequestFormService,
    private router: Router,
    private getDataService: GetDataService,
    private activatedRouter: ActivatedRoute,
  ) {
    super();
    this.formStepDataUberLto = this.frmBuilder.group({
      hasUber: ['', [Validators.required]],
    });

  }

  ngOnInit(): void {
    if (this.requestFormService.getUpdateForm()) {
      this.accessLoginUber();
    }

    this.saveRequest.subscribe((value) => {
      if (value) {
        this.saveStepDataUber();
      } else {
        this.stepDataUberLtoSavedEvent.emit(true)
      }
    });

    this.checkEvent();
  }

  checkEvent() {
    this.formValidEvent.emit(this.enableButtonApproved || this.requestFormService.getUpdateForm().palenca.hasPalencaAccount);
  }

  saveStepDataUber() {
    const putUpdateRequestDataUberLto$ = this.putDataService
      .putUpdateRequestDataUberLto(
        this.getCountry().toUpperCase(),
        this.getApplicationId()
      )
      .subscribe((resp) => {
        resp.approved
          ? this.stepDataUberLtoSavedEvent.emit(true)
          : this.openDialogValidUber(resp.causes![0]);
        sessionStorage.setItem(
          'docsUber',
          resp.includeUberDocumentCategory.toString()
        );
      });
    this.subscriptions.push(putUpdateRequestDataUberLto$);
  }

  openDialogUber() {
    window.open(`${environment.apiurluberLto}`, '', 'width=900,height=900');
    this.accessLoginUber();
  }

  openDialogValidUber(value: Cause) {
    let errorMessage = 'Ha ocurrido un error.';

    const errorCodeToken = `TOKEN`.match(value.code);
    const errorCodeBlock = `Block`.match(value.code);
    const errorCodeYounger = `Younger`.match(value.code);
    const errorCodeAdult = `Adult`.match(value.code);
    const errorCodeScore = `Adult`.match(value.code);
    const success = `Success`.match(value.code);
    const errorCodeTrips = `TRIPS`.match(value.code);

    if (errorCodeToken) {
      errorMessage = `Habilite el acceso a sus datos de Uber para continuar.`; // se reinicia formulario, mail de rechazo, estado en captura.
    }
    if (errorCodeBlock) {
      errorMessage = `Uber nos informa que su cuenta está bloqueada,
      regularice su situación para avanzar. Para requerir mayor información comunícate al teléfono ..`; //Falta telefono, reinicia formulario, mail rechazo
    }
    if (errorCodeYounger) {
      errorMessage = `Muchas gracias por su solicitud, cuando cumpla con la edad requerida de 24 años vuelva a realizar la solicitud.`; //reinicia formulario, mail rechazo, estado segumimiento edad
    }
    if (errorCodeAdult) {
      errorMessage = `Muchas gracias por su solicitud, de acuerdo a la información proporcionada no cumple con los requisitos para ser acreditado.`; //reinicia formulario. estado rechazada definitiva. se envia mail
    }
    if (errorCodeScore) {
      errorMessage = `Muchas gracias por su solicitud, de acuerdo a la información proporcionada por Uber cuenta con menos de 4.7
      estrellas por lo que no es viable por el momento, por favor continue haciendo viajes de mayor calificación y cuando tenga 4.7 estrellas vuelva a intentarlo.`; //reinicia formulario. estado seguimineto calificacion. se envia mail
    }
    if (success) {
      errorMessage = `Felicitaciones, ya fuiste preautorizado para que se te otorgue un créditocon Vemo Impulso.`;
    }
    if (errorCodeTrips) {
      errorMessage = `Muchas gracias por su solicitud, de acuerdo a la información proporcionada por Uber no cumple con los viajes totales realizados requeridos.`; //reinicia formulario. total de viajes. se envia mail
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Información de solicitud',
      question: errorMessage,
    };
    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => {
        this.router.navigate(['/busqueda']);
        sessionStorage.clear();
      });
  }

  getApplicationId() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('applicationId')!
      : this.requestFormService.getUpdateForm().id;
  }

  getCountry() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('language')!
      : this.requestFormService.getUpdateForm().countryCode.code.toLowerCase();
  }

  accessLoginUber() {
    setTimeout(() => {
      const getConsultLoginUberLto$ = this.getDataService
        .getConsultLoginUberLto(
          this.getCountry().toUpperCase(),
          this.getApplicationId()
        )
        .subscribe((resp) => {
          this.enableButtonApproved = resp.isLogged;
          this.accessLoginUber();
          this.checkEvent();
        });
      this.subscriptions.push(getConsultLoginUberLto$);
    }, 5000);
  }
}
